// extracted by mini-css-extract-plugin
export var discard = "_4p-3";
export var muiTooltipTooltip = "_4p-5";
export var notificationBar = "_4p-2";
export var saveButtonHoverSlotWrapper = "_4p-4";
export var show = "_4p-1";
export var spacer = "_4p-0";